import { useStep18Query, useStep18Write, type AttendanceHistory, type AttendanceMark, type AttendanceShift, type TeamCheck, type TurnoverBranch } from "./use-staff-turnover";

export type AttendanceBranch=TurnoverBranch&{
 today:string;day:string;attendanceDayEnd:string;canSave:boolean;
 checked:boolean;by?:string|null;actorName?:string|null;createdAt?:string|null;updatedAt?:string|null;changedBy?:string|null;
 people:TeamCheck["people"];marks:AttendanceMark[];history?:AttendanceHistory[];shifts?:AttendanceShift[];
};
export type AttendanceGridCell={
 branchId:string;day:string;checked:boolean;working?:number;notWorking?:number;changed?:boolean;changedBy?:string|null;history?:AttendanceHistory[];
};
export type StaffAttendanceData={
 today:string;day:string;branchToday:boolean;canCheck:boolean;canDecideLateSick:boolean;isBranchManager?:boolean;
 branches:AttendanceBranch[];days:string[];grid:AttendanceGridCell[];shifts?:AttendanceShift[];
};
export function useStaffAttendance(day?:string){
 return useStep18Query<StaffAttendanceData>(`/api/staff/attendance${day?`?day=${encodeURIComponent(day)}`:""}`);
}
export const useStaffAttendanceWrite=()=>useStep18Write<{saved?:boolean;leftEmployeeIds?:string[]}>();
export async function uploadAttendancePhoto(file:File,workspaceId:string){
 if(!["image/jpeg","image/png","image/webp"].includes(file.type))throw new Error("Use a JPEG, PNG or WebP image.");
 if(file.size>3*1024*1024)throw new Error("Photo must be 3 MB or smaller.");
 const response=await fetch("/api/staff/attendance-photos",{method:"POST",credentials:"include",headers:{"Content-Type":file.type,"x-workspace-id":workspaceId},body:file});
 const result=await response.json();
 if(!response.ok)throw new Error(result.message||response.statusText);
 return result as {key:string};
}
export async function readAttendancePhoto(historyId:string,workspaceId:string){
 const response=await fetch(`/api/staff/attendance-history/${encodeURIComponent(historyId)}/photo`,{credentials:"include",headers:{"x-workspace-id":workspaceId}});
 if(!response.ok)throw new Error("Could not load evidence photo.");
 return response.blob();
}
export const attendanceShiftId=(shift:AttendanceShift)=>shift.id||shift.key||"";
export const attendanceShiftName=(shift:AttendanceShift,rtl:boolean)=>rtl&&shift.nameAr?shift.nameAr:shift.nameEn||shift.name||shift.key||shift.id||"";
export const attendanceStatusClass=(status:string)=>({working:"work",day_off:"off",no_show:"noshow"}[status]||status);
export function attendanceDate(day:string,rtl:boolean,options:Intl.DateTimeFormatOptions={weekday:"long",day:"numeric",month:"long"}){
 const date=new Date(`${day.slice(0,10)}T12:00:00Z`);
 return Number.isNaN(date.getTime())?day:date.toLocaleDateString(rtl?"ar-EG-u-nu-latn":"en-GB",{...options,timeZone:"UTC"});
}
export function attendanceTime(value?:string|null,rtl=false){
 if(!value)return "";
 const date=new Date(value);
 return Number.isNaN(date.getTime())?value:date.toLocaleString(rtl?"ar-EG-u-nu-latn":"en-GB",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"});
}
